import axios from "axios";
import router from "../router";
import store from "../store";
import { getStore } from "../utils/localStorage";
import { isNull } from "../utils/base";
import { Message } from "element-ui";

// 服务器地址
// const baseURL = "http://192.168.1.109:9501";
// const baseURL = "https://cqwlxy-api.guizhizikao.cn";
// const baseURL = "http://www.easyswoole9510.com";
const baseURL = process.env.VUE_APP_BASE_URL;

export {
  baseURL
};
axios.defaults.baseURL = baseURL;

//axios.defaults.withCredentials = true

/**
 * 请求拦截器
 */
axios.interceptors.request.use(
  (config) => {
    const token = getStore("token");
    if (token) {
      config.headers = {
        token: token,
        "content-type": "text/plain;charset=utf-8",
      };
    }

    const  apiUrl = replaceApiUrl(config.url)
    config.url = apiUrl
    return config;
  },
  (error) => {
    endLoading();
    return Promise.reject(error);
  }
);
// 请求失败提示语
let messageTimer = true;
const errorTisp = '出现错误，请联系管理员处理';
axios.interceptors.response.use(
  (response) => {
    endLoading();
    if(response.data === ''){
        Message.error(errorTisp);
        return Promise.reject(errorTisp);
    }else{
        // return Promise.resolve(response.data);
        return response;
    }
    // return response;
  },
  (error) => {
    if (error.response.status == 401) {
      // window.sessionStorage.clear();
      // window.localStorage.clear();
      store.dispatch('permission/logOut');
      router.replace("/Login");
    }
    if (error.response && error.response.data) {
      if (messageTimer) {
        messageTimer = false;
        Message.error({
          message: error.response.data.msg ? error.response.data.msg : "请求失败",
        });
        setTimeout(() => {
          messageTimer = true;
        }, 2000);
      }
    }

    endLoading();
    return Promise.reject(error);
  }
);
/**
 * 加载动画(多个请求合并一次loading)
 */
let reqNum = 0;

function startLoading() {
  if (reqNum == 0) {
    store.commit("common/loading", true);
  }
  reqNum++;
}

function endLoading() {
  setTimeout(closeLoading, 50);
}

function closeLoading() {
  if (reqNum <= 0) return;
  reqNum--;
  if (reqNum == 0) {
    store.commit("common/loading", false);
  }
}

/**
 * axios 的简单封装
 */
export default class Ajax {
  /**
   * 经过错误处理的请求方式
   * @param url 接口地址
   * @param param 参数
   * @param isLoad 是否显示加载框
   */
  static async get(url, param, isLoad = true) {
    if (isLoad) {
      startLoading();
    }
    const result = await axios.get(url, {
      params: param,
    });
    return Ajax.handleError(result);
  }

  static async post(url, param, isLoad = true) {
    if (isLoad) {
      startLoading();
    }
    const result = await axios.post(url, param);
    return Ajax.handleError(result);
  }

  static async delete(url, param, isLoad = true) {
    if (isLoad) {
      startLoading();
    }
    const result = await axios.delete(url, {
      data: param,
    });
    return Ajax.handleError(result);
  }

  static async put(url, param, isLoad = true) {
    if (isLoad) {
      startLoading();
    }
    const result = await axios.put(url, param);
    return Ajax.handleError(result);
  }

  static async patch(url, param, isLoad = true) {
    if (isLoad) {
      startLoading();
    }
    const result = await axios.patch(url, param);
    return Ajax.handleError(result);
  }

  static async handleError(result) {
    if ((result && result.status === 200) || result.status === 201) {
      const {
        data
      } = result;

      if (data.code === 200) {
        return data;
      }

      return undefined;
    }

    return Promise.reject();
  }

  /**
   * 文件下载
   * @param url 接口地址
   * @param param 参数
   * @param isLoad 是否显示加载框
   */
  static async downLoad(url, param, isLoad = true) {
    if (isLoad) {
      startLoading();
    }
    const result = await axios.get(url, {
      params: param,
      responseType: "blob",
    });
    return result;
  }

  /**
   * 未做错误处理的请求方式
   */
  static async unsafeGet(url, param, headers, isLoad = true) {
    if (isLoad) {
      startLoading();
    }
    const result = await axios.get(url, {
      params: param,
      headers: headers,
    });
    return result;
  }

  static async unsafePost(url, param, headers, isLoad = true) {
    if (isLoad) {
      startLoading();
    }
    const result = await axios.post(url, param, {
      headers: headers,
    });
    return result;
  }

  static async codeLogin(url, param, headers) {
    const result = await axios.post(url, param, {
      headers: headers,
    });
    return result;
  }

  static async unsaDelete(url, param, isLoad = true) {
    if (isLoad) {
      startLoading();
    }
    const result = await axios.delete(url, {
      data: param,
    });
    return result;
  }

  static async unsaPut(url, param, isLoad = true) {
    if (isLoad) {
      startLoading();
    }
    const result = await axios.put(url, param);
    return result;
  }
}


// apiUrl替换
function replaceApiUrl(url){
  const entranceType = getStore('_ENTRANCETYPE')
  if(url.indexOf('/fs-') <= -1){
    return url
  }
  if(entranceType == 'own'){
    return url.replace('fs-','v1-own-student-')
  }
  else if(entranceType == 'adult'){
    return url.replace('fs-','v1-adult-student-')
  }else if(entranceType === 'practicalAssessment'){
    return url.replace('fs-','v1-own-student-')
  }
  else{
    window.sessionStorage.clear();
    window.localStorage.clear();
    router.replace("/");
  }
}
